module.exports = __webpack_public_path__ + "img/title.f02e7845.png";